<template>
  <div>
    <shipblu-card v-if="type === 'Add Delivery Order'" class="md:p-6 p-5 mb-3 md:flex gap-4">
      <div class="md:w-1/2">
        <p class="mb-4 text-lg font-medium text-black">{{$t('How will we get your package?')}}</p>
        <div class="flex flex-wrap gap-x-2 gap-y-6 service-level">
          <div v-for="(dropOff, index) in dropOffChoices" :key="index">
            <label @click="checkedItem(dropOff, dropOffChoices)" class="cursor-pointer checked-border">
              <input v-model="shipment.is_counter_dropoff" :class="dropOff.checked ? 'checked' : ''" :value="dropOff.id" type="radio" />
              <span class="py-2 pl-7 rounded font-medium leading-tight" :class="dropOff.name === 'Counter DropOff' ? 'pr-6' : 'pr-3'">{{ $t(dropOff.name) }}</span>
              <vx-tooltip v-if="dropOff.name === 'Counter DropOff'" class="info-icon" position="top" color="dark" :text="`${$t('Choose this option if you will drop the Package to the nearest ShipBlu Branch')}`">
                <span class="material-icons-outlined text-sm">info</span>
              </vx-tooltip>
            </label>
          </div>
        </div>
      </div>
      <div class="md:w-1/2 md:mt-0 mt-6" v-if="shipment.is_counter_dropoff && (shipment.is_counter_dropoff === 2 || shipment.is_counter_dropoff.id === 2)">
        <p class="text-lg font-medium text-black mb-2">{{type === 'Add Delivery Order' ? $t('Select your pickup Location:') : $t('Select your dropoff point:')}}</p>
        <v-select class="select-border w-full" v-model="shipment.pickupPoint" v-validate="'required'"
          :placeholder="$t('Pickup Point')" name="pickup point" label="fullAddress" :options="pickupPoints"/>
        <span class="text-danger text-sm" v-show="errors.has('pickup point')">{{ errors.first('pickup point') }}</span>
      </div>
    </shipblu-card>
   
  </div>
</template>
<script>
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import vSelect from 'vue-select'

export default {
  props: ['shipment', 'pickupPoints', 'type'],
  data () {
    return {
      dropOffChoices: [
        {
          id: 2,
          name: 'Pickup from your location',
          checked: true
        },
        {
          id: 1,
          name: 'Counter DropOff',
          checked: false
        }
      ]
    }
  },
  watch: {
    'shipment.is_counter_dropoff' (val) {
      if (typeof (val) === 'object') {
        this.shipment.is_counter_dropoff = this.shipment.is_counter_dropoff.id
      }
    }
  },
  methods:{
    checkedItem (element, array) {
      array.forEach(item => {
        if (item.name === element.name) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    }
  },
  components: {
    ShipbluCard,
    vSelect
  }
}
</script>